import React, { useState } from "react";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css"; // Import the drawer styles
import { FaBars, FaTimes, FaGithub, FaLinkedin, FaSun, FaMoon } from "react-icons/fa"; // Icons for social links and theme toggle
import { FaXTwitter } from "react-icons/fa6";

function NavBar({ darkMode, toggleDarkMode }) {
  const [isOpen, setIsOpen] = useState(false);

  // Toggle drawer state
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId).scrollIntoView({ behavior: "smooth" });
    setIsOpen(false); // Close drawer after navigation
  };

  return (
    <div className="fixed top-0 left-0 w-full z-50 bg-white dark:bg-gray-900 shadow-md">
      <nav className="flex justify-between items-center py-4 px-6 md:px-16">
        {/* Hamburger Icon for Mobile */}
        <div className="md:hidden">
          <FaBars
            className="text-2xl cursor-pointer dark:text-white"
            onClick={toggleDrawer}
          />
        </div>

        {/* Desktop Navigation */}
        <ul className="hidden md:flex space-x-8 text-gray-700 dark:text-gray-300">
          <li>
            <button
              onClick={() => scrollToSection("home")}
              className="hover:text-blue-500"
            >
              Home
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection("about")}
              className="hover:text-blue-500"
            >
              About
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection("techstack")}
              className="hover:text-blue-500"
            >
              Tech Stack
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection("projects")}
              className="hover:text-blue-500"
            >
              Projects
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection("testimonials")}
              className="hover:text-blue-500"
            >
              Testimonials
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection("contact")}
              className="hover:text-blue-500"
            >
              Contact
            </button>
          </li>
        </ul>

        {/* Desktop Social Links and Dark Mode Toggle */}
        <div className="flex space-x-6 items-center text-gray-500 dark:text-gray-400">
          {/* Dark Mode Toggle Button */}
          <button
            onClick={toggleDarkMode}
            className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors duration-200 flex items-center justify-center"
            aria-label="Toggle dark mode"
            title={darkMode ? "Switch to light mode" : "Switch to dark mode"}
          >
            {darkMode ? (
              <FaSun className="text-yellow-500 text-lg" />
            ) : (
              <FaMoon className="text-gray-700 dark:text-gray-300 text-lg" />
            )}
          </button>
          <a
            href="https://github.com/AbdulWadood2"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGithub className="text-xl hover:text-blue-500" />
          </a>
          <a
            href="https://x.com/AbdulWa34577265?t=87rFg9kIXdLhlX1cTNcN6A&s=09"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaXTwitter className="text-xl hover:text-blue-500" />
          </a>
          <a
            href="https://www.linkedin.com/in/abdul-wadood-ba9414246/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin className="text-xl hover:text-blue-500" />
          </a>
        </div>

        {/* Drawer for Mobile */}
        <Drawer
          open={isOpen}
          onClose={toggleDrawer}
          direction="left"
          className="bg-white dark:bg-gray-900"
        >
          <div className="p-6 space-y-4">
            <FaTimes
              className="text-2xl cursor-pointer"
              onClick={toggleDrawer}
            />

            <ul className="space-y-6 text-gray-700 ">
              <li>
                <button
                  onClick={() => scrollToSection("home")}
                  className="hover:text-blue-500"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("about")}
                  className="hover:text-blue-500"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("techstack")}
                  className="hover:text-blue-500"
                >
                  Tech Stack
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("projects")}
                  className="hover:text-blue-500"
                >
                  Projects
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("testimonials")}
                  className="hover:text-blue-500"
                >
                  Testimonials
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("contact")}
                  className="hover:text-blue-500"
                >
                  Contact
                </button>
              </li>
            </ul>

            {/* Dark Mode Toggle and Social Links in Drawer */}
            <div className="space-y-4">
              {/* Dark Mode Toggle Button */}
              <button
                onClick={toggleDarkMode}
                className="flex items-center space-x-2 p-2 rounded-lg bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors duration-200 w-full"
                aria-label="Toggle dark mode"
              >
                {darkMode ? (
                  <>
                    <FaSun className="text-yellow-500 text-lg" />
                    <span className="text-gray-700 dark:text-gray-300">Light Mode</span>
                  </>
                ) : (
                  <>
                    <FaMoon className="text-gray-700 dark:text-gray-300 text-lg" />
                    <span className="text-gray-700 dark:text-gray-300">Dark Mode</span>
                  </>
                )}
              </button>
              
              {/* Social Links */}
              <div className="flex space-x-6 text-gray-500 dark:text-gray-400">
                <a
                  href="https://github.com/AbdulWadood2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaGithub className="text-xl hover:text-blue-500" />
                </a>
                <a
                  href="https://x.com/AbdulWa34577265?t=87rFg9kIXdLhlX1cTNcN6A&s=09"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaXTwitter className="text-xl hover:text-blue-500" />
                </a>
                <a
                  href="https://www.linkedin.com/in/abdul-wadood-ba9414246/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin className="text-xl hover:text-blue-500" />
                </a>
              </div>
            </div>
          </div>
        </Drawer>
      </nav>
    </div>
  );
}

export default NavBar;
